@if ((isCreationProcess$ | async) === false) {
  <div class="app-name-container">
    <div class="flex mt-2 relative w-full">
      <div class="w-full flex flex-col">
        <!-- name input -->
        <label class="font-bold mb-3 text-xl">
          {{ 'assets.app-name' | translate }}
        </label>
        <rk-app-name-input
          [appName]="appName"
          (appNameChange)="onAppNameChange($event)"
          [greyBackground]="true"
          [small]="true"
          class="asset-section-app-name-input"
        ></rk-app-name-input>
      </div>
    </div>
  </div>
}
